<script setup lang="ts"></script>

<template>
   <div class="error"><i class="fa-solid fa-triangle-exclamation"></i><span>Error page</span></div>
</template>

<style lang="scss" scoped>
.error {
   display: flex;
   justify-content: center;
   align-items: center;
   flex-direction: column;

   width: 100%;
   height: 100%;
}

.fa-triangle-exclamation {
   margin-bottom: var(--nxt-gutter);
}
</style>
